var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lockers",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.75,
    height: 35.75,
    viewBox: "0 0 35.75 35.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5451",
    "data-name": "Group 5451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5450",
    "data-name": "Group 5450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14594",
    "data-name": "Path 14594",
    d: "M64.813,65.625h4.875a.812.812,0,1,0,0-1.625H64.813a.812.812,0,1,0,0,1.625Z",
    transform: "translate(-59.125 -59.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14595",
    "data-name": "Path 14595",
    d: "M69.688,106.667H64.813a.812.812,0,1,0,0,1.625h4.875a.812.812,0,1,0,0-1.625Z",
    transform: "translate(-59.125 -98.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14596",
    "data-name": "Path 14596",
    d: "M256.813,65.625h4.875a.812.812,0,1,0,0-1.625h-4.875a.812.812,0,1,0,0,1.625Z",
    transform: "translate(-236.5 -59.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14597",
    "data-name": "Path 14597",
    d: "M262.5,107.479a.812.812,0,0,0-.812-.813h-4.875a.813.813,0,0,0,0,1.625h4.875A.812.812,0,0,0,262.5,107.479Z",
    transform: "translate(-236.499 -98.541)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14598",
    "data-name": "Path 14598",
    d: "M150.146,170.667a.812.812,0,0,0-.812.813v3.25a.813.813,0,0,0,1.625,0v-3.25A.812.812,0,0,0,150.146,170.667Z",
    transform: "translate(-137.958 -157.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14599",
    "data-name": "Path 14599",
    d: "M341.333,174.729a.813.813,0,1,0,1.625,0v-3.25a.813.813,0,1,0-1.625,0Z",
    transform: "translate(-315.333 -157.666)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 1.625,
    cy: 1.625,
    r: 1.625,
    transform: "translate(29.25 22.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14600",
    "data-name": "Path 14600",
    d: "M30.875,19.582V3.25A3.254,3.254,0,0,0,27.625,0h-9.75a3.23,3.23,0,0,0-2.437,1.123A3.23,3.23,0,0,0,13,0H3.25A3.254,3.254,0,0,0,0,3.25V26a3.254,3.254,0,0,0,3.25,3.25H13a3.23,3.23,0,0,0,2.437-1.123,3.23,3.23,0,0,0,2.437,1.123h4.539l-2.676,2.676a.812.812,0,0,0-.238.574v2.437a.812.812,0,0,0,.813.813H22.75a.812.812,0,0,0,.574-.238l4.937-4.936a5.591,5.591,0,0,0,1.8.3,5.675,5.675,0,0,0,.812-11.293ZM14.625,26A1.627,1.627,0,0,1,13,27.625H3.25A1.627,1.627,0,0,1,1.625,26V3.25A1.627,1.627,0,0,1,3.25,1.625H13A1.627,1.627,0,0,1,14.625,3.25Zm3.25,1.625A1.627,1.627,0,0,1,16.25,26V3.25a1.627,1.627,0,0,1,1.625-1.625h9.75A1.627,1.627,0,0,1,29.25,3.25V19.582a5.679,5.679,0,0,0-4.875,5.605,5.553,5.553,0,0,0,.3,1.8l-.636.636ZM30.062,29.25a4.015,4.015,0,0,1-1.665-.366.809.809,0,0,0-.909.166l-5.075,5.075H21.125V32.836L26.2,27.761a.813.813,0,0,0,.167-.909,4.057,4.057,0,1,1,3.7,2.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockers);
export default __webpack_public_path__ + "static/media/lockers.799bb363500a218473bd0f48e0775aac.svg";
export { ForwardRef as ReactComponent };